"use client";

import { memo, useCallback, useEffect, useRef, useState } from "react";

export const ImageLoaderHandler = memo(
  /**
   * @typedef {object} Props
   * @prop {string} src
   * @prop {(params: { ref: import("react").MutableRefObject<HTMLImageElement | null>; src: string; loaded: boolean; handleLoad: () => void }) => React.ReactElement} children
   */
  /**
   * Use this component to load images EXCLUSIVELY for background images and animate them when they are loaded.
   * @param {Props} props
   */
  function ImageLoaderHandler({ src, children }) {
    const [loaded, setLoaded] = useState(true);

    /** @type {import("react").MutableRefObject<HTMLImageElement | null>} */
    const ref = useRef(null);

    // set loading state on mount
    useEffect(() => {
      setLoaded(ref.current?.complete === true);
    }, [src]);

    const handleLoad = useCallback(() => {
      setLoaded(true);
    }, []);

    return children({
      ref,
      src,
      loaded,
      handleLoad,
    });
  },
);
